import { useQuery } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import { emptyFilterCriteria } from '@/components/table/types/FilterCriteriaDto.tsx';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { FilterFieldOperator } from '@/components/table/_filterFieldOperators/FilterFieldOperator.ts';
import { TourExpenseListDto } from '@/features/dashboard/expenses/types/TourExpenseListDto.ts';

/**
 * Wiersz globalnej listy wydatków po identyfikatorze. Szczegół wydatku wymaga
 * `tourId`, którego alokacja transakcji nie niesie, a wiersz listy niesie `tour`.
 */
const useGetExpenseListRow = (expenseId: string) =>
  useQuery<TourExpenseListDto | null>({
    queryKey: [...expensesApiQueryKeys.global(), 'row', expenseId],
    queryFn: async () => {
      const page = await expensesApi.getAllGlobal(
        { page: 0, size: 1 },
        {
          ...emptyFilterCriteria,
          filters: [
            {
              fieldId: 'id',
              type: FieldType.ID,
              operator: FilterFieldOperator.EQUALS,
              value: expenseId,
            },
          ],
        },
      );
      return page.content[0] ?? null;
    },
    enabled: Boolean(expenseId),
    staleTime: 1000 * 60,
  });

export default useGetExpenseListRow;
